/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcTableSelectionInfo
 * @restrict E
 * @element span
 * @description
 * The wcTableSelectionInfo directive is responsible for get the number of selected rows from the datatable
 */



angular.module('WcResponsiveTableModule').directive('wcTableSelectionInfo', function() {
	return {
		restrict: 'E',
        template: '<span>{{tableSelectionInfoController.numberOfSelectedRows}} {{"rowsCurrentlySelected" | translate}}</span>',
        require: ['wcTableSelectionInfo', '^wcResponsiveTable', '^ngModel'],
		scope: {},
		controllerAs: 'tableSelectionInfoController',
		controller: ['$scope', '$element', function($scope, $element) {
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			var tableScope = responsiveTableController.WcTableScopeService.getTableScope();

			this.numberOfSelectedRows = responsiveTableController.ngModel.length;
			tableScope.$watch(function() {
				return responsiveTableController.ngModel.length;
			}, angular.bind(this, function(newVal, oldVal) {
					if(newVal != oldVal) {
						this.numberOfSelectedRows = newVal;
					}
			}));
		}]
	};
});
